import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId
const getNamespace = () => store.state.app.namespace

export default {
  namespaced: true,
  state: {
    serviceSetResultInfo: {},
    services: [],
    service: {},
    fetchingServices: false,
    addingService: false,
    removingService: false,
  },
  mutations: {
    SET_SERVICES(state, data) {
      state.services = data.result
    },
    SET_SERVICE(state, data) {
      state.service = data.result
    },
    SET_FETCHING_SERVICES(state, value) {
      state.fetchingServices = value
    },
    SET_ADDING_SERVICE(state, value) {
      state.addingService = value
    },
    SET_REMOVING_SERVICE(state, value) {
      state.removingService = value
    },
  },
  actions: {
    fetchServices({ commit }) {
      commit('SET_FETCHING_SERVICES', true)
      return new Promise((resolve, reject) => {
        api('kyubi').get(`projects/${getProjectId()}/namespaces/${getNamespace()}/services`)
          .then(response => {
            commit('SET_SERVICES', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_SERVICES', false) })
      })
    },
    getService({ commit }, service) {
      commit('SET_FETCHING_SERVICES', true)
      return new Promise((resolve, reject) => {
        api('kyubi').get(`projects/${getProjectId()}/namespaces/${getNamespace()}/service/${service}`)
          .then(response => {
            commit('SET_SERVICE', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_SERVICES', false) })
      })
    },
    addService({ commit }, service) {
      commit('SET_ADDING_SERVICE', true)
      return new Promise((resolve, reject) => {
        api('kyubi').post(`projects/${getProjectId()}/namespaces/${getNamespace()}/service`, service)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_ADDING_SERVICE', false) })
      })
    },
    removeService({ commit }, service) {
      commit('SET_REMOVING_SERVICE', true)
      return new Promise((resolve, reject) => {
        api('kyubi').delete(`projects/${getProjectId()}/namespaces/${getNamespace()}/service/${service}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_REMOVING_SERVICE', false) })
      })
    },
  },
}
